import React from 'react'
import ActivityLog from '../../../components/Dashboards/Operations/activityLog'
import { useParams } from 'react-router-dom';

function ActivityLogPage() {
    const { id } = useParams();
  return <ActivityLog company_id={id as string} />;
}

export default ActivityLogPage